import styles from "./navigation.module.scss";
import { useState, useEffect } from "react";
import MobileNavigation from "./MobileNavigation";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const pages = [
    "features",
    "solution",
    "benefits",
    "references",
    "team",
    "contact",
  ];

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`${styles.navigation} ${isScrolled ? styles.scrolled : ''}`}>
      <div className={styles.navigation__inner}>
        <a href="#home" className={styles.logoLink}>
          <div className={styles.logoContainer}>
            <img
              alt="Biolean logo"
              src="/media/images/BioLean_Logo_Transparent.png"
            />
          </div>
        </a>

        <div className={styles.menuOptions}>
          {pages.map((page) => (
            <a href={`#${page}`} className={styles.menuItems} key={page}>
              {page}
            </a>
          ))}
        </div>

        <MobileNavigation isOpen={isOpen} setIsOpen={setIsOpen} items={pages} />
      </div>
    </header>
  );
};

export default Navigation;
